import PropTypes from 'prop-types';
import React from 'react';

import Illustration from '@wetransfer/transfer/component/illustration';
import { FF_UPSELL_DESTINATION_EXPERIMENT } from '@wetransfer/transfer/constant/experiments';
import {
  createProRoute,
  createPricingRoute,
} from '@wetransfer/transfer/helper/routeFactory';
import { getVariant } from '@wetransfer/transfer/modules/experiments';
import I18n from '@wetransfer/transfer/modules/i18n';

const Upsell = ({
  upsellKey,
  onHandleUpsellClick,
  onNewTransfer,
  illustrationType,
}) => {
  const upsellDestinationFF =
    getVariant(FF_UPSELL_DESTINATION_EXPERIMENT) === 'on';

  const linkOptions = {
    href: upsellDestinationFF
      ? createProRoute('WT202006_tooltip_options')
      : createPricingRoute(),
    onClick: onHandleUpsellClick,
  };

  // External links are external
  if (linkOptions['href'].match(/^https?/)) {
    linkOptions['rel'] = 'external';
  }

  return (
    <React.Fragment>
      <div className="transfer__contents">
        <div className="transfer__upsell">
          <Illustration type={illustrationType || `transfer-${upsellKey}`} />
          <h2>{I18n.t(`transfer.${upsellKey}.title`)}</h2>
          <p>
            <a {...linkOptions} data-variant={upsellKey}>
              {I18n.t(`transfer.${upsellKey}.text`)}
            </a>
          </p>
        </div>
      </div>
      <div className="transfer__footer">
        <button className="transfer__button" onClick={onNewTransfer}>
          {I18n.t('transfer.buttons.continue')}
        </button>
      </div>
    </React.Fragment>
  );
};

Upsell.propTypes = {
  upsellKey: PropTypes.string.isRequired,
  onHandleUpsellClick: PropTypes.func.isRequired,
  onNewTransfer: PropTypes.func.isRequired,
  href: PropTypes.string,
  illustrationType: PropTypes.string,
};

export default Upsell;
